export default __webpack_public_path__ + "static/media/before-you-start.56ac495e.png";